import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found">
            <div className="not-found-content">
                <h1 className="not-found-title">BioSite</h1>
                <h2 className="not-found-subtitle">Aradığınız sayfa bulunamadı</h2>
                <p className="not-found-description">Yanlış bir bağlantı kullanmış olabilirsiniz ya da sayfa taşınmış olabilir.</p>
                <div className="not-found-actions">
                    <button 
                        className="not-found-button primary"
                        onClick={() => navigate('/')}
                    >
                        Ana Sayfaya Dön
                    </button>
                    <button 
                        className="not-found-button secondary"
                        onClick={() => navigate('/dashboard')}
                    >
                        Dashboard'a Git
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;

